import { Injectable } from "@angular/core";
import { set, get, del, setMany, getMany, delMany } from 'idb-keyval';

@Injectable({
    providedIn: 'root'
})
export class KeyvalService {

    popItem(key: string): any {
        return get(key).then(item => {
            return del(key).then(() => {
                return item;
            });
        });
    }

    getItem(key: string): any {
        return get(key);
    }

    setItem(key: string, value: any): Promise<void> {
        return set(key, value);
    }

    async setMany(entries: [string, any][]): Promise<void> {
        return setMany(entries);
    }

    async getMany(keys: string[]): Promise<any[]> {
        return getMany(keys);
    }

    async deleteMany(keys: string[]): Promise<void> {
        return delMany(keys);
    }

}